import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledPagination, StyledPaginationBullet } from '../styled';

interface PaginationProps {
  activeIndex: number;
  slideCount: number;
  onBulletClick?: (index: number) => void;
}

export const Pagination: FC<PaginationProps> = ({
  activeIndex,
  slideCount,
  onBulletClick,
}) => {
  const { t } = useTranslation('common');

  if (slideCount <= 1) return null;

  return (
    <StyledPagination>
      {Array.from({ length: slideCount }, (_, index) => (
        <StyledPaginationBullet
          key={index}
          active={index === activeIndex}
          onClick={() => onBulletClick?.(index)}
          role="button"
          aria-label={t('pagination.goToSlide', { number: index + 1 })}
          aria-current={index === activeIndex ? 'true' : undefined}
        />
      ))}
    </StyledPagination>
  );
};
